module.exports = __webpack_public_path__ + "static/DIMDATA-664c606e17a4bbe8c46fbeb311d696bd.png";